import axios from "axios";

class MempoolService {
    baseURL = ''
    constructor(isTestNet: boolean = false) {
        if(isTestNet){
            this.baseURL = 'https://mempool.space/testnet'
        } else {
            this.baseURL = 'https://mempool.space'
        }
    }
    async hasValidUTXO(id: any, index: any){
        let key = `v1.${this.baseURL}:isValid:${id}:${index}`
        let cached = localStorage.getItem(key)
        if(cached?.length){
            return JSON.parse(cached)
        }

        let result = false
        try{
            // @ts-ignore
            let data: any = await axios.get(`${this.baseURL}/api/tx/${id}/outspends`, {ignore: true})
            let info: any = data.data?.[index]
            if(info){
                let status: any = info.status
                result = !(info.spent && status?.confirmed)
            }

        }
        catch (e){
            result = false
        }

        if(!result){
            localStorage.setItem(key, JSON.stringify(result))
        }

        return result
    }
}

class TestnetMempoolService extends MempoolService {
    constructor(){
        super(true)
    }
}

export {MempoolService, TestnetMempoolService}
